import { useEffect } from "react";

const SITE = "https://findleystmedia.com";
const DEFAULT_TITLE = "Findley St Media — Web Design & Development Studio";
const DEFAULT_DESC =
  "Professional websites and useful business tools, without the unnecessary price tag. Explore working examples or start a custom project with Findley St Media.";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Per-route SEO: title, description, canonical, OG/Twitter. The static head in
// index.html is the crawler floor; these refine each route (visible to prerendered bots).
export function Seo({ title, description, path = "/", noindex = false }) {
  useEffect(() => {
    const t = title ? `${title} — Findley St Media` : DEFAULT_TITLE;
    const d = description || DEFAULT_DESC;
    const url = `${SITE}${path}`;

    document.title = t;
    upsertMeta("name", "description", d);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    upsertCanonical(url);
    upsertMeta("property", "og:title", t);
    upsertMeta("property", "og:description", d);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:title", t);
    upsertMeta("name", "twitter:description", d);
  }, [title, description, path, noindex]);

  return null;
}
